import { motion } from 'framer-motion';
import { CheckCircle2, XCircle, AlertCircle, Lightbulb } from 'lucide-react';
import Card from '../ui/Card';

export default function SectionInclusions({ data }) {
  if (!data) return null;

  return (
    <section id="inclusions" className="section-padding bg-gradient-to-br from-secondary-900 via-secondary-950 to-black">
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">{data.title}</h2>
          {data.description && (
            <p className="text-xl text-secondary-200 max-w-3xl mx-auto">
              {data.description}
            </p>
          )}
        </motion.div>

        <div className="max-w-6xl mx-auto space-y-8">
          {/* CE QUI EST INCLUS */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <Card className="bg-green-900/20 border-2 border-green-500/50">
              <h3 className="text-2xl font-bold text-white mb-6">{data.included.title}</h3>

              <div className="grid md:grid-cols-3 gap-6">
                {data.included.categories.map((category, index) => (
                  <div key={index} className="space-y-3">
                    <h4 className="text-lg font-semibold text-green-300 mb-4">
                      {category.title}
                    </h4>
                    <ul className="space-y-2">
                      {category.items.map((item, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <CheckCircle2
                            size={18}
                            className="text-green-400 flex-shrink-0 mt-0.5"
                          />
                          <span className="text-green-100/90 text-sm">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </Card>
          </motion.div>

          {/* PREMIUM */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <Card className="bg-amber-900/20 border-2 border-amber-500/50">
              <div className="flex items-start gap-4 mb-6">
                <div className="p-3 bg-amber-500/20 text-amber-400 rounded-lg">
                  <AlertCircle size={24} />
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-white mb-4">{data.premium.title}</h3>
                  <ul className="space-y-2">
                    {data.premium.items.map((item, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <CheckCircle2
                          size={18}
                          className="text-amber-400 flex-shrink-0 mt-0.5"
                        />
                        <span className="text-amber-100/90">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Card>
          </motion.div>

          {/* CE QUI N'EST PAS INCLUS */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <Card className="bg-red-900/20 border-2 border-red-500/50">
              <h3 className="text-2xl font-bold text-white mb-6">{data.notIncluded.title}</h3>

              <ul className="space-y-3 mb-4">
                {data.notIncluded.items.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <XCircle
                      size={18}
                      className="text-red-400 flex-shrink-0 mt-0.5"
                    />
                    <span className="text-red-100/90">{item}</span>
                  </li>
                ))}
              </ul>

              {data.notIncluded.note && (
                <p className="text-red-200/70 text-sm italic mt-4 pl-7">
                  {data.notIncluded.note}
                </p>
              )}
            </Card>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
